/* eslint-disable quote-props */
module.exports = {
  'Customer Panel': '客戶專家組',
  'User account management panel.': '用戶帳戶管理面板。',
  'User Id': '用戶身份',
  'Password': '密碼',
  'Enter user id': '輸入用戶ID',
  'Enter password': '輸入密碼',
  'Log In': '登錄',
  'Don\'t have an account ?': '沒有賬號？',
  'Open Live Account': '開立真實賬戶',
  // views/login/index.js
  'Dashboard': '儀表板',
  // views/layout/sidebar.js
};
